import React from 'react'
import PropTypes from 'prop-types'
import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import fastSellProductCurationFormSchema from './fast-sell-product-curation-form-schema'
import fastSellProductCurationFormInitialValues from './fast-sell-product-curation-form-initial-values'
import { CURATION_STATUS, REJECT_LABEL } from 'domains/fast-sell-product/constants'


const propTypes = {
  fastSellProduct: PropTypes.shape({
    id                     : PropTypes.number,
    curation_status        : PropTypes.string,
    curation_reject_label  : PropTypes.string,
    curation_reject_reason : PropTypes.string
  }),
  onClickSubmit : PropTypes.func,
  disabled      : PropTypes.bool
}

const defaultProps = {
  fastSellProduct : {},
  onClickSubmit   : () => { },
  disabled        : false
}

const FastSellProductCurationForm = ({
  onClickSubmit,
  fastSellProduct,
  disabled
}) => {

  const statusRejected = (formik) => {
    const curationStatus = formik.values.curation_status
    if (curationStatus !== CURATION_STATUS.REJECTED) {
      formik.values.curation_reject_label  = ''
      formik.values.curation_reject_reason = ''
    }
    return curationStatus == CURATION_STATUS.REJECTED
  }

  return (
    <Formik
      initialValues={ fastSellProductCurationFormInitialValues(fastSellProduct) }
      enableReinitialize={ true }
      validationSchema={ fastSellProductCurationFormSchema }
      onSubmit={ onClickSubmit }
    >
      {
        (formik) => (
          <Form>
            <InputField
              type={ 'select' }
              formGroupClassName={ 'mr-3' }
              name={ 'curation_status' }
              label={ 'Curation Status' }
              bsSize={ 'sm' }
              disabled={ disabled }
            >
              <InputSelectOptions
                options={ CURATION_STATUS }
              />
            </InputField>
            {
              statusRejected(formik) && (
                <>
                  <InputField
                    type={ 'select' }
                    formGroupClassName={ 'mr-3' }
                    name={ 'curation_reject_label' }
                    label={ 'Curation Reject Label' }
                    bsSize={ 'sm' }
                    disabled={ disabled }
                  >
                    <InputSelectOptions
                      options={ REJECT_LABEL }
                    />
                  </InputField>
                  <InputField
                    type={ 'text' }
                    name={ 'curation_reject_reason' }
                    label={ 'Curation Reject Reason' }
                    formText={ 'Alasan mengapa barang ini di reject' }
                    disabled={ disabled }
                  />
                </>
              )
            }

            <div className='text-right'>
              <LoaderButton
                color='primary'
                type='submit'
                disabled={ formik.isSubmitting || disabled }
                isLoading={ formik.isSubmitting }
                text='Update Curation'
              />
            </div>
          </Form>
        )
      }
    </Formik>
  )
}

FastSellProductCurationForm.propTypes    = propTypes
FastSellProductCurationForm.defaultProps = defaultProps

export default FastSellProductCurationForm
